import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lp-page" }
const _hoisted_2 = {
  class: "lp-breadcrumb",
  "aria-label": "breadcrumb"
}
const _hoisted_3 = { class: "lp-breadcrumb__current" }
const _hoisted_4 = {
  key: 1,
  class: "lp-card course-locked"
}
const _hoisted_5 = { class: "course-locked__icon" }
const _hoisted_6 = { class: "course-layout" }
const _hoisted_7 = {
  key: 3,
  class: "container text-center itens-center mb-10"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_9 = { class: "text-muted fs-3 fw-bold mt-5" }

import { useStore } from "vuex";
import { computed, onMounted, ref } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import router from "@/router";
import { UserType } from "@/types/UserType";
import CourseAchievementModal from "@/components/achivements/Course.vue";
import HcIcon from "@/modern/components/ui/HcIcon.vue";
import CourseHero from "@/modern/components/training/courses/CourseHero.vue";
import CourseModuleList from "@/modern/components/training/courses/CourseModuleList.vue";
import CourseSidebar from "@/modern/components/training/courses/CourseSidebar.vue";
import { ICourse, currentModuleOf, useCourseI18n } from "@/modern/components/training/courses/course";
import "@/modern/styles/lp.scss";


export default /*#__PURE__*/_defineComponent({
  props: { id: { type: String, required: true } },
  setup(__props) {

const props = __props

const store = useStore();

const { t, lang: currentLanguage, tc } = useCourseI18n();

const user = computed<UserType>(() => store.getters.currentUser);
const course = computed<ICourse>(() => store.getters.getCurrentCourse);
const courseAccessDenied = computed(() => store.getters.getCourseAccessDenied);
const showSpinner = ref(false);
const showCourse = ref(false);
const achivementModal = ref<InstanceType<typeof CourseAchievementModal> | null>(null);

onMounted(async () => {
  showSpinner.value = true;
  try {
    await store.dispatch(Actions.GET_COURSE, props.id);

    if (courseAccessDenied.value) {
      showCourse.value = false;
    } else if (typeof (course.value.id) === 'undefined') {
      await router.push('/training/course-catalog');
    } else {
      showCourse.value = true;
      if (course.value && course.value.achievement && !course.value.achievement.is_read && achivementModal.value) {
        achivementModal.value.openModal();
      }
    }
  } catch (e) {
    console.error('Error loading course:', e);
    await router.push('/training/course-catalog');
  } finally {
    showSpinner.value = false;
  }
})

const currentModule = computed(() => currentModuleOf(course.value.modules));

const completedModulesCount = computed(() => {
  return course.value.modules?.filter(module => module.module_status === 'completed').length || 0;
});

const totalLessonsCount = computed<number>(() => {
  return store.getters.getStatistics?.total_lessons ?? course.value.lessons_count ?? 0;
});

const completedLessonsCount = computed<number>(() => {
  return store.getters.getStatistics?.total_completed_lessons ?? 0;
});

const completionMessage = computed(() => {
  const completed = completedModulesCount.value;
  const total = course.value.modules?.length || 0;

  if (completed === 0) {
    return t(`${currentLanguage.value}.common.you_have_not_completed_any_modules_yet`);
  } else if (completed === total && total > 0) {
    return t(`${currentLanguage.value}.common.you_have_completed_all_modules`);
  } else if (completed === 1) {
    return t(`${currentLanguage.value}.common.you_have_completed_at_least_one_module_so_far`);
  } else {
    return `${completed} ${t(`${currentLanguage.value}.common.modules_so_far`)}`;
  }
});

const explode = async () => {
  await achivementModal.value?.openModal();
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(course) && _unref(course).achievement && _unref(course).has_achievement == true)
      ? (_openBlock(), _createBlock(CourseAchievementModal, {
          key: 0,
          ref_key: "achivementModal",
          ref: achivementModal,
          course: _unref(course)
        }, null, 8, ["course"]))
      : _createCommentVNode("", true),
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/dashboard",
        class: "lp-breadcrumb__home"
      }, {
        default: _withCtx(() => [
          _createVNode(HcIcon, {
            name: "home",
            size: 16
          })
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: { name: 'course-catalog' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(tc)('breadcrumb_root')), 1)
        ]),
        _: 1
      }),
      (showCourse.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(HcIcon, {
              name: "chevron-right",
              size: 12,
              class: "lp-breadcrumb__sep"
            }),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(course).name), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_unref(courseAccessDenied))
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(HcIcon, {
              name: "lock",
              size: 26
            })
          ]),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.module.unlock_your_full_potential`)), 1),
          _createVNode(_component_router_link, {
            to: { name: 'profile-billing' },
            class: "lp-btn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.subscribe`)) + " ", 1),
              _createVNode(HcIcon, {
                name: "arrow",
                size: 16
              })
            ]),
            _: 1
          })
        ]))
      : (showCourse.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(CourseHero, {
              course: _unref(course),
              "current-module": _unref(currentModule),
              "lessons-done": _unref(completedLessonsCount),
              "lessons-total": _unref(totalLessonsCount),
              "modules-done": _unref(completedModulesCount),
              greeting: _unref(completionMessage),
              "user-nick": _unref(user).nick || 'No nick',
              onShare: explode
            }, null, 8, ["course", "current-module", "lessons-done", "lessons-total", "modules-done", "greeting", "user-nick"]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(CourseModuleList, {
                modules: _unref(course).modules || [],
                "current-module-id": _unref(currentModule)?.id ?? null
              }, null, 8, ["modules", "current-module-id"]),
              _createVNode(CourseSidebar, {
                course: _unref(course),
                "current-module": _unref(currentModule),
                "lessons-done": _unref(completedLessonsCount),
                "lessons-total": _unref(totalLessonsCount),
                "modules-done": _unref(completedModulesCount)
              }, null, 8, ["course", "current-module", "lessons-done", "lessons-total", "modules-done"])
            ])
          ], 64))
        : _createCommentVNode("", true),
    (showSpinner.value && !_unref(courseAccessDenied))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, "   Hacking " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.user_progress.in_progress`)) + "...", 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})